import script from "./PresenceReportNew.vue?vue&type=script&setup=true&lang=js"
export * from "./PresenceReportNew.vue?vue&type=script&setup=true&lang=js"

import "./PresenceReportNew.vue?vue&type=style&index=0&id=7f9fd4f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f9fd4f7"]])

export default __exports__